import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import getItem from 'owa-mail-store/lib/services/getItem';
import isItemView from '../utils/isItemView';
import type ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import { loadSuggestedRepliesData } from '../actions/loadSuggestedRepliesData';
import { orchestrator } from 'satcheljs';
import { updateSuggestedReplies } from 'owa-mail-store/lib/actions/updateSuggestedReplies';

/**
 * This orchestrator is executed when in conversation view to update the suggested replies data
 */
export const loadSuggestedRepliesDataOrchestrator = orchestrator(
    loadSuggestedRepliesData,
    async actionMessage => {
        const { itemId } = actionMessage;

        if (!isItemView()) {
            const itemShape = itemResponseShape({
                BaseShape: 'IdOnly',
                AdditionalProperties: [
                    extendedPropertyUri({
                        PropertyName: 'EntityExtraction/SmartReplyForEmail',
                        DistinguishedPropertySetId: 'Common',
                        PropertyType: 'String',
                    }),
                ],
            });

            getItem(itemId, itemShape).then(response => {
                if (checkIfResponseSuccess(response)) {
                    const responseItem = response as ItemInfoResponseMessage;
                    if (responseItem.Items[0]?.ExtendedProperty) {
                        updateSuggestedReplies(itemId, responseItem.Items[0]);
                    }
                }
            });
        }
    }
);
